import { ComponentStyleConfig } from "@chakra-ui/react";

export const inputFieldDisabledProps = {
  borderRadius: 4,
  bgColor: "grey.50",
  borderColor: "grey.500",
  opacity: 1,
  color: "grey.600",
};

const Input: ComponentStyleConfig = {
  baseStyle: {
    field: {
      borderRadius: 4,
      _disabled: inputFieldDisabledProps,
    },
  },
};

export default Input;
